import React, { Component } from 'react'
import { Link, browserHistory } from 'react-router';
import {
  ChiTietDon,
  QuaTrinhXuLy,
} from 'modules/giai-quyet-don/subView';
import { ShowIf } from 'components/utils';
import { GiaiQuyetDonThu, LetterProcessingWorkFlow, Letter, Reception } from 'api';
import { CheckViewPermission } from 'modules/login/CheckPermission';
import { HuongXuLyView } from 'modules/handle-letters/xu-ly-don/form-xu-ly';
import { ContainerFileDinhKem } from 'components/upload';
import moment from 'moment';
import { Toastr } from 'modules/toastr';
import { msg } from 'constants/message';

const loaiTepDinhKem = "QUYET_DINH";
const loaiQuyTrinh = "XU_LY_DON";
const buocGiaiQuyet = "BO_SUNG_SAU_KHI_CHUYEN_DON_LUU_HO_SO";

class BoSungThongTinChuyenDon extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      id: this.props.params.id,
      data: {},
      dataLichSuQuaTrinhXuLy: [],
      dataKetQuaXuLyDon: {},
      loaiDon: 'DON_KHIEU_NAI',
      isOpen: true,
      backConfirm: false,
      listTaiLieuVanThuBoSungHoSo: [],
      hideQuaTrinhXuLy: false,
      thongTinXuLyGiaiQuyet: {},
      title: 'Thông tin đã xử lý',
      listTaiLieuVanThu: [],
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      taiLieuVanThu: [],
      dataFileDinhKem: [],
      listTaiLieuVanThuChuyenDonBoSungHoSo: [],
      dataLichSuGiaiQuyet: [],
    }
  }

  componentDidMount() {
    this.getDonDetail();
    this.getQuyTrinhXuLyHistory();
  }

  getDonDetail() {
    let params = {
      id: this.state.id
    }
    Letter.actions.getDonDetail.request(params).then(res => {
      if (res.data) {
        if (CheckViewPermission(res.data)) {
          Reception.actions.getDonInfo.request({ id: this.state.id }).then(resDonInfo => {
            if (resDonInfo.data) {
              res.data = {...res.data, ...resDonInfo.data};
            }
            let dataKetQuaXuLyDon = {
              thamQuyenGiaiQuyet: res.data.thamQuyenGiaiQuyetInfo ? res.data.thamQuyenGiaiQuyetInfo.ten : ''
            }
            let donId = res.data.donId
            this.getThongTinXuLyHoacGiaiQuyet(donId);
            this.setState({
              data: res.data,
              loaiDon: res.data.loaiDon,
              dataKetQuaXuLyDon: dataKetQuaXuLyDon,
              listTaiLieuVanThuChuyenDonBoSungHoSo: res.data.listTaiLieuVanThuChuyenDonBoSungHoSo,
              listTaiLieuVanThuBoSungHoSo: res.data.listTaiLieuVanThuBoSungHoSo,
              listTaiLieuVanThu: res.data.taiLieuVanThus || []
            });
          });
        } else {
          browserHistory.push('/page-403');
        }

      }
    });
  }

  getQuyTrinhXuLyHistory() {
    LetterProcessingWorkFlow.actions.getQuyTrinhXuLyHistory.request({ donId: this.state.id }).then(res => {
      if(res.data._embedded) {
        this.setState({ dataLichSuQuaTrinhXuLy: res.data ? res.data._embedded.lichSuQuaTrinhXuLies : [] });
      }
    });
  }

  getThongTinXuLyHoacGiaiQuyet(donId) {
    LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(res => {
      if (res.data) {

        let info = res.data;

        this.setState({
          thongTinXuLyGiaiQuyet: info.thongTinXuLyInfo,
        });
      }
    }).catch(error => {});
  }

  handleBack(allowBack) {
    if (allowBack) {
      browserHistory.goBack();
    } else {
      if (this.state.hasChange) {
        this.setState({backConfirm: true});
      } else {
        browserHistory.goBack();
      }
    }
  }

  onFileRemove(id, data) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ],
      dataFileDinhKem: data
    });
    this.handleChangeData();
    //
  }

  onFileChange(data) {
    this.setState ({
      dataFileDinhKem: data
    });
    this.handleChangeData();
  }

  handleChangeData() {
    this.setState({
      hasChange: true
    })
  }
  handleSave() {
    this.setState({
      btnLoading: true,
      btnSaveLoading: true
    });
    this.state.dataFileDinhKem.map((item, i) => {
      if (item.duongDan === '') {
        // DO nothing
      } else if (item.taiLieuVanThuId) {
        let state = this.state;
        state.taiLieuVanThuUpdate[state.taiLieuVanThuUpdate.length] = {
          don: {
            id: Number(this.state.id)
          },
          id: item.taiLieuVanThuId,
          ten: item.ten,
          soQuyetDinh: item.soQuyetDinh,
          ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
          tenFile: item.tenFile,
          duongDan: item.duongDan,
          loaiTepDinhKem: item.loaiTepDinhKem,
          loaiQuyTrinh: item.loaiQuyTrinh,
          buocGiaiQuyet: item.buocGiaiQuyet,
          required: item.required,
          typeRequired: item.typeRequired ? item.typeRequired : ''
        };
        this.setState({state});
      } else {
        let state = this.state;
        state.taiLieuVanThu[state.taiLieuVanThu.length] = {
          don: {
            id: Number(this.state.id)
          },
          ten: item.ten,
          soQuyetDinh: item.soQuyetDinh,
          ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
          tenFile: item.tenFile,
          duongDan: item.duongDan,
          loaiTepDinhKem: loaiTepDinhKem,
          buocGiaiQuyet: buocGiaiQuyet,
          loaiQuyTrinh: loaiQuyTrinh,
          required: item.required,
          typeRequired: item.typeRequired ? item.typeRequired : ''
        };
        this.setState({state})
      }
    });

    if (this.state.dataTaiLieuVanThuDelete.length > 0) {
      this.state.dataTaiLieuVanThuDelete.map(item => {
        this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
          id: item
        };
      });
    }
    if (this.state.taiLieuVanThu.length > 0) {
      let params = {
        taiLieuVanThus: this.state.taiLieuVanThu
      }
      this.postTaiLieuVanThu(params);
    }
    if (this.state.taiLieuVanThuUpdate.length > 0) {
      let params = {
        taiLieuVanThus: this.state.taiLieuVanThuUpdate
      }
      this.updateTaiLieuVanThu(params);
    }
    if(this.state.taiLieuVanThuDelete.length > 0) {

      let params = {
        taiLieuVanThus: this.state.taiLieuVanThuDelete
      }
      this.deleteTaiLieuVanThu(params);
    }
    this.saveGiaiQuyetDon('gqdLuu');

  }

  updateTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  deleteTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  saveGiaiQuyetDon(message) {
    this.onClickClose();
    Toastr(message ? msg[message] : msg.luuGiaiQuyetDonThanhCong, 'success');
  }

  onClickClose() {
    browserHistory.goBack();
  }

  render() {
    return (
      <div className="center">
        <div className="back-foward">
          <Link onClick={ this.handleBack.bind(this, false) } title="">Về trang trước</Link>
        </div>
        <div className="heading">
          <h2 className="heading-title icon-detail">Thông tin giải quyết đơn/vụ việc</h2>
        </div>
        <div className="page-wrapper">
          <ChiTietDon isOpen={this.state.isOpen} donId={this.state.id} loaiDon={this.state.loaiDon} dataGiaiQuyet={this.state.dataLichSuGiaiQuyet} data={this.state.data}/>
        </div>
        <div className="page-wrapper">
          <ShowIf condition={this.state.hideQuaTrinhXuLy != true}>
            <QuaTrinhXuLy parents={this}/>
          </ShowIf>
        </div>
        <div className="page-wrapper">
          <div className="wrap-big-line pl20">
            <h2 className="title-14 mb25 pt10">{this.state.title}</h2>
          </div>
          <HuongXuLyView
            loaiDonGiaTri={this.state.loaiDon}
            thongTinXuLyGiaiQuyet={this.state.thongTinXuLyGiaiQuyet}
            thongTinGQD={this.state.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
            donInfo={this.state.data}
            listTaiLieuVanThu={this.state.listTaiLieuVanThu}/>
        </div>
        <div className="page-wrapper mb30">
          <h2 className="title-14 mb15">Bổ sung thông tin</h2>
            <div className="row pl10 pr10">
              <div className="col-100 pb5">
                <ContainerFileDinhKem onSave={this.state.onSave} label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.listTaiLieuVanThuChuyenDonBoSungHoSo} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
              </div>
          </div>
        </div>
        <div className="box-bottom pt10 mb40">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.handleBack.bind(this, false)}><span>Đóng</span></Link>
            <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu</span></Link>
          </div>
      </div>
    )
  }
}

export default BoSungThongTinChuyenDon


// WEBPACK FOOTER //
// ./src/components/modules/bo-sung-thong-tin/BoSungThongTinChuyenDon.jsx